(() => {
  const bind = (root) => {
    root.querySelectorAll('[data-tk-sort]').forEach((select) => {
      if (select.dataset.tkBound) return;
      select.dataset.tkBound = 'true';
      const submit = select.form.querySelector('.tk-sort-submit');
      if (submit) submit.hidden = true;
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        url.hash = 'tweedekans-aanbod';
        window.location.assign(url.toString());
      });
    });
  };
  bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
